import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute, Params } from "@angular/router";
import { Router } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl
} from "@angular/forms";

import { CrudService } from "../../../crud/crud.service";

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import "jspdf-autotable";
import * as $ from "jquery";
import { Mensaje } from "../../../mensaje";
import { NotificationsService } from 'angular2-notifications';
import { isUndefined } from "util";

import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-horario-formulario",
  templateUrl: "./horario-docente.component.html"
})
export class HorarioDocenteComponent implements OnInit{
  @ViewChild("periodoAnterior") periodoAnterior: ElementRef;
  @ViewChild("modalidad") modalidad: ElementRef;
  @ViewChild("tipoPeriodo") tipoPeriodo: ElementRef;

  dato: FormGroup;

  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  API_PATH = environment.API_PATH;

  profesores_horarios = [];
  profesorhorario;
  ph_modulos = [];
  ph_dias = [];
  ph_horas = [];
  ph_modalidades = [];
  ph_modalidades_dias: number[] = [];
  ph_parciales = [];

  dias_semanas = ["Ninguno", "Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"];

  profesor_sel;
  periodo_sel;
  cargando = false;

  logo_sucursal = "";
  logo_empresa = "";
  activos = true;

  mensajeResponse: Mensaje = new Mensaje(true);
  //mostrar notificaciones
  public options = {
    position: ["middle", "center"],
    timeOut: 3000,
    lastOnBottom: true
  };

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private crud: CrudService,
    private notificacion: NotificationsService
  ) {}

  ngOnInit() {
    this.dato = this.fb.group({
      id: [""]
    });
    document.getElementById("catalogos").click();
  }
  seleccionarPeriodo(event) {
    if(event){
      if (event.hasOwnProperty("value")) {
        this.periodo_sel =  event.value;
      }else{
        this.periodo_sel = event;
      }
    }

    if ((this.periodo_sel || this.activos) && this.profesor_sel)
      this.profesorHorario();
  }
  seleccionarProfesor(event) {
    if(event){
      if (event.hasOwnProperty("value")) {
        this.profesor_sel =  event.value;
      }else{
        this.profesor_sel = event;
      }
    }

    if ((this.periodo_sel || this.activos) && this.profesor_sel)
      this.profesorHorario();
  }
  seleccionarActivos(event) {
    if ((this.periodo_sel || this.activos) && this.profesor_sel)
      this.profesorHorario();
  }
  parametros = {
    pagina: 0,
    limite: 0
  };
  profesorHorario() {
    this.cargando = true;
    try {
      this.ph_modulos = [];
      this.ph_dias = [];
      this.ph_horas = [];
      this.ph_modalidades = [];
      this.profesorhorario = [];

      this.crud
        .lista(
          this.parametros,
          "profesor-horario" +
            "?periodos_escolares_id=" +
            this.periodo_sel +
            "&personas_id=" +
            this.profesor_sel +
            "&activos=" +
            this.activos
        )
        .subscribe(
          resultado => {
            this.cargando = false;
            if (resultado.status == 200) {
              let ph_horas = [];
              let ph_dias = [];
              let ph_modulos = [];
              let ph_modalidades = [];
              let ph_modalidades_dias = [];
              let ph_parciales = [];
              this.profesorhorario = resultado.data;

              this.profesorhorario.horario = [];
              this.profesorhorario.parciales = [];
              this.profesorhorario.modulos_periodos_escolares.forEach( element => {
                  let elmodulo = element.fecha_inicio + " al " + element.fecha_fin;
                  let modalidad = element.modalidades.nombre;
                  ph_modalidades.push(modalidad);

                  if (typeof ph_horas[modalidad] == "undefined"){
                    ph_horas[modalidad] = [];
                    ph_modalidades_dias[modalidad] = element.modalidades.modalidades_dias.length;
                  }
                  if (typeof ph_dias[modalidad] == "undefined")
                    ph_dias[modalidad] = [];
                  if (typeof ph_modulos[modalidad] == "undefined")
                    ph_modulos[modalidad] = [];

                  if (typeof ph_parciales[modalidad] == "undefined")
                    ph_parciales[modalidad] = [];

                  ph_parciales[modalidad][elmodulo] = element.periodos_escolares_parciales;

                  ph_modulos[modalidad].push(elmodulo);

                  if (typeof this.profesorhorario.horario == "undefined"){
                    this.profesorhorario.horario = [];
                    this.profesorhorario.parciales = [];
                  }

                  if (typeof this.profesorhorario.horario[modalidad] == "undefined"){
                    this.profesorhorario.horario[modalidad] = [];
                  }

                  if (typeof this.profesorhorario.horario[modalidad][elmodulo] == "undefined"){
                    this.profesorhorario.horario[modalidad][elmodulo] = [];
                  }

                  element.horarios_dias.forEach(elem => {
                    ph_dias[modalidad].push(elem.dias_semanas.id);
                    if ( typeof this.profesorhorario.horario[modalidad][elmodulo][ elem.dias_semanas.id ] == "undefined" )
                      this.profesorhorario.horario[modalidad][elmodulo][ elem.dias_semanas.id ] = [];

                    elem.horarios_detalles.forEach(el => {
                      let elhora = el.hora_inicio + "-" + el.hora_termino;
                      if ( typeof this.profesorhorario.horario[modalidad][ elmodulo ][elem.dias_semanas.id][elhora] == "undefined" )
                        this.profesorhorario.horario[modalidad][elmodulo][ elem.dias_semanas.id ][elhora] = null;

                      if (el.materias.nombre && el.materias.nombre != "") {
                        this.profesorhorario.horario[modalidad][elmodulo][ elem.dias_semanas.id ][elhora] = {
                          nombre: el.materias.nombre,
                          clave: el.materias.clave,
                          grupo: element.grupos.clave + ' ' + element.grupos.nivel + ' ' + element.grupos.identificador,
                          modalidad: element.modalidades.nombre,
                          turno: element.turnos.nombre
                        };
                        ph_horas[modalidad].push(elhora);
                      }
                    });
                  });
                }
              );
              this.ph_modalidades = this.arrayUnico(ph_modalidades);
              this.ph_parciales = ph_parciales;
              this.ph_modalidades_dias =  ph_modalidades_dias;

              ph_modalidades.forEach(modalidad => {
                this.ph_horas[modalidad] = this.arrayUnico( ph_horas[modalidad] ).sort();
                this.ph_dias[modalidad] = this.arrayUnico(ph_dias[modalidad]).sort();
                this.ph_modulos[modalidad] = this.arrayUnico( ph_modulos[modalidad] );
              });
            }
          },
          error => {
            this.cargando = false;
          }
        );
    } catch (e) {
      console.log(e);
    }
  }

  arrayUnico(array) {
    return array.filter(function(valor, indiceActual, arreglo) {
      let indiceAlBuscar = arreglo.indexOf(valor);
      if (indiceActual === indiceAlBuscar) {
        return true;
      } else {
        return false;
      }
    });
  }

  generarPDF() {
    let color = "#FFFFFF"; //$(".hero.is-primary").css("background-color");
    let doc = new jsPDF("landscape", "mm", "letter");
    let lineas = 5;
    this.ph_modalidades.forEach((modalidad, m) => {
      let logo =
        this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
      if (logo != "") doc.addImage(logo, "PNG", 10, 5, 25, 25, "", "FAST");
      //Nombre empresa
      doc.setFontSize(15);
      doc.setFont("helvetica", "", "bold");
      doc.setFont("helvetica");
      doc.text(this.configuracion.empresa.nombre,140, 12,  {align:"center"});

      doc.setFontSize(14);
      doc.setFont("helvetica", "", "bold");
      doc.text(this.configuracion.empresa.subnombre,140, 18,  {align:"center"});

      doc.setFontSize(10);
      doc.setFont("helvetica", "", "normal");
      doc.text("Campus: " + this.configuracion.sucursal.nombre,140, 24,  {align:"center"});

      doc.setFontSize(10);
      doc.setFont("helvetica", "", "bold");
      doc.text("HORARIO DOCENTE",138, 30,  {align:"center"});

      doc.setFontSize(8);
      doc.setFont("helvetica", "", "bold");
      doc.text(this.profesorhorario.docente.nombre, 140, 35, {align:"center"} );
      lineas = 40;
      if (this.ph_modalidades_dias[modalidad] > 2) {
        this.ph_modulos[modalidad].forEach((modulo, i) => {
          let res = (doc as any).autoTableHtmlToJson(document.getElementById("tabla" + i));
          (doc as any).autoTable(res.columns, res.data, {
            didParseCell: function(cell, data) {
              cell.cell.styles.fillColor = "#ffffff";
            },
            startY: lineas,
            styles: {
              fontSize: 6, font: "helvetica",
              halign: "center",
              fillColor: "#FFFFFF",
              textColor: "#000000",
              lineColor: "#000000",
              lineWidth: 0.3
            },
            headStyles: {
              lineColor: "#000000",
              lineWidth: 0.3
            },
            bodyStyles: {
              overflow: 'linebreak',
              cellPadding: 0.8
            },
            theme: "grid",
            margin: { right: 10, left: 10 },
          });
          lineas += res.data.length * 18;

          if (i < this.ph_modulos[modalidad].length - 1) {
            lineas = 5;
            doc.addPage();
          }
        });
      }else{
        let columns = [];

        this.ph_dias[modalidad].forEach(dia => {
          columns.push({
            title: this.dias_semanas[dia],
            dataKey: dia
          });
        });

        (doc as any).autoTable(columns, [], {
          didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
            cell.styles.fillColor = "#ffffff";
          },
          startY: lineas,
          styles: {
            fontSize: 6, font: "helvetica",
            halign: "center",
            fillColor: "#FFFFFF",
            textColor: "#000000",
            lineColor: "#000000",
            lineWidth: 0.3
          },
          headStyles: {
            lineColor: "#000000",
            lineWidth: 0.3
          },
          bodyStyles: {
            overflow: 'linebreak',
            cellPadding: 0.8
          },
          theme: "grid",
          margin: { right: 10, left: 10 },
        });
        lineas += 6;
        columns = [{ title: "Hora", dataKey: "hora" }];

        this.ph_modulos[modalidad].forEach(modulo => {
          columns.push({
            title: modulo,
            dataKey: modulo
          });
        });

        let rows = [];

        this.ph_horas[modalidad].forEach(hora => {
          rows.push({});
          this.ph_dias[modalidad].forEach(dia => {
            this.ph_modulos[modalidad].forEach(modulo => {
              let info = '';
              if (this.profesorhorario.horario[modalidad][modulo][dia][hora]) {
                info = this.profesorhorario.horario[modalidad][modulo][dia][hora].nombre + '\n' +
                this.profesorhorario.horario[modalidad][modulo][dia][hora].clave + '\n' +
                this.profesorhorario.horario[modalidad][modulo][dia][hora].grupo + '\n' +
                this.profesorhorario.horario[modalidad][modulo][dia][hora].turno;
              }
              rows[rows.length - 1]["hora"] = hora;
              rows[rows.length - 1][modulo] = info;
            });
          });
        });

        (doc as any).autoTable({
            columns:columns, 
            body: rows,
          didParseCell: function(cell, data) {
            cell.cell.styles.fillColor = "#ffffff";
          },
          startY: lineas,
          styles: {
            fontSize: 6, font: "helvetica",
            halign: "center",
            fillColor: "#FFFFFF",
            textColor: "#000000",
            lineColor: "#000000",
            lineWidth: 0.3
          },
          headStyles: {
            lineColor: "#000000",
            lineWidth: 0.3
          },
          bodyStyles: {
            overflow: 'linebreak',
            cellPadding: 0.8
          },
          theme: "grid",
          margin: { right: 10, left: 10 },
        });
        lineas += rows.length * 18 + 10;

      }

      this.ph_modulos[modalidad].forEach((modulo, i) => {
        let columns = [
          { title: "Modulo", dataKey: "modulo" },
          { title: "Parcial", dataKey: "id" },
          { title: "Fecha de inicio", dataKey: "inicio" },
          { title: "Fecha de termino", dataKey: "termino" }
        ];
        let rows = [];

        this.ph_parciales[modalidad][modulo].forEach(p1=> {
          rows.push({
            modulo: modulo,
            id: p1.numero_parcial,
            inicio: p1.fecha_inicio,
            termino: p1.fecha_fin
          });
        });

        (doc as any).autoTable({
            columns:columns, 
            body: rows,
          didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
            cell.styles.fillColor = "#ffffff";
          },
          startY: lineas,
          styles: {
            fontSize: 6, font: "helvetica",
            halign: "center",
            fillColor: "#FFFFFF",
            textColor: "#000000",
            lineColor: "#000000",
            lineWidth: 0.3
          },
          bodyStyles: {
            overflow: 'linebreak',
            cellPadding: 0.8
          },
          headStyles: {
            lineColor: "#000000",
            lineWidth: 0.3
          },
          theme: "grid",
          margin: { right: 10, left: 10 },
        });
        lineas += rows.length * 6 + 10;
      });

      if (this.profesorhorario.periodos_escolares.nota_docentes) {
        this.profesorhorario.periodos_escolares.nota_docentes = this.profesorhorario.periodos_escolares.nota_docentes.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
       
        doc.fromHTML(this.profesorhorario.periodos_escolares.nota_docentes, 10, lineas + 10, {
          width: 530
        });
      }
      if (m < this.ph_modalidades.length - 1) {
        lineas = 5;
        doc.addPage();
      }
    });
    // doc.autoPrint();
    //const string = (doc as any).output("datauristring", "horario_docente.pdf");
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe =
      "<iframe border='0' style='border:0px' width='100%' height='100%' src='" +
      string +
      "'></iframe>";

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }

  asignarLogos(logos) {
    this.logo_sucursal = logos.sucursal;
    this.logo_empresa = logos.empresa;
  }
}
